// extracted by mini-css-extract-plugin
export default {"wrapper":"new-participant-setup-flow_wrapper__t2TuH","opacity-transition":"new-participant-setup-flow_opacity-transition__r0XBq"};